module.exports = __webpack_public_path__ + "static/media/gold-coast-suns-logo.f49b11cf.svg";